export const MESSAGE_SELECTED_CLASS = 'bg-background text-foreground shadow-sm'
export const NOTE_SELECTED_CLASS =
  'bg-yellow-100 text-yellow-800 shadow-sm dark:bg-yellow-900/50 dark:text-yellow-300'
